module.exports = require("react-dates/lib/defaultPhrases");